import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../views/LogoutView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/assemble',
      name: 'assemble',
      component: () => import('../views/AssembleView.vue')
    },
    {
      path: '/stack',
      name: 'stack',
      component: () => import('../views/StackView.vue')
    }
  ]
})

export default router
